import { Component, ElementRef, OnDestroy, OnInit, ChangeDetectionStrategy, inject, viewChild } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { SearchService } from '../../services/search.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
	selector: 'vex-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatIconButton, MatIcon, ReactiveFormsModule, AsyncPipe],
})
export class SearchComponent implements OnInit, OnDestroy {
	private layoutService = inject(LayoutService);
	private searchService = inject(SearchService);

	show$ = this.layoutService.searchOpen$;
	searchCtrl = new UntypedFormControl();

	readonly input = viewChild<ElementRef>('searchInput');

	ngOnInit() {
		this.searchService.isOpenSubject.next(true);
		this.searchCtrl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => this.searchService.valueChangesSubject.next(value));

		this.show$
			.pipe(
				filter((show) => show),
				untilDestroyed(this)
			)
			.subscribe(() => this.input().nativeElement.focus());
	}

	close() {
		this.layoutService.closeSearch();
		this.searchCtrl.setValue(undefined);
		this.searchService.isOpenSubject.next(false);
	}

	search() {
		this.searchService.submitSubject.next(this.searchCtrl.value);
		this.close();
	}

	ngOnDestroy(): void {
		this.layoutService.closeSearch();
		this.searchCtrl.setValue(undefined);
		this.searchService.isOpenSubject.next(false);
	}
}
